import { ErrorMessage, Field, Form, Formik } from "formik"
import { PoolPortalPartofmonth } from "modules/PoolPortal/helpers/types"
import { usePartofmonths } from "modules/PoolPortal/hooks/usePartofmonthsAPI"
import { DefaultValidationSchema } from "modules/PoolPortal/utils"
import { Form as BootstrapForm, Button, Spinner } from "react-bootstrap"
import * as Yup from "yup"

interface PartofmonthsAdminEntryPageProps {
  data: PoolPortalPartofmonth
  setShowEntryBlade: (show: boolean) => void
}

const validationSchema = Yup.object().shape({
  ...DefaultValidationSchema(['code']),
})

export const PartofmonthsAdminEntryPage = ({
  data,
  setShowEntryBlade,
}: PartofmonthsAdminEntryPageProps) => {
  const { createPartofmonth, updatePartofmonth } = usePartofmonths()

  const isEditMode = !(Object.keys(data).length === 0 || data.id === "")

  const handleSubmit = async (values: PoolPortalPartofmonth) => {
    // Handle form submission
    if (!isEditMode) {
      await createPartofmonth(values as PoolPortalPartofmonth)
    } else {
      await updatePartofmonth({
        ...data,
        ...{
          name: values.name,
          description: values.description,
        },
      } as PoolPortalPartofmonth)
    }

    setShowEntryBlade(false)
  }

  const handleCancel = () => {
    setShowEntryBlade(false)
  }

  return (
    <Formik
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="PoolPortal_AdminEntryBody d-flex flex-column">
            <div className="mb-3">
              <BootstrapForm.Label htmlFor="name" as="h5">
                Name:
              </BootstrapForm.Label>
              <Field
                type="text"
                id="name"
                name="name"
                default={data.name}
                className="form-control"
              />
              <ErrorMessage
                name="name"
                component="div"
                className="PoolPortal_ErrorMessage"
              />
            </div>
            <div className="mb-3">
              <BootstrapForm.Label htmlFor="description" as="h5">
                Description:
              </BootstrapForm.Label>
              <Field
                as="textarea"
                id="description"
                name="description"
                default={data.description}
                className="form-control"
                style={{ height: "60px" }}
              />
              <ErrorMessage
                name="description"
                component="div"
                className="PoolPortal_ErrorMessage"
              />
            </div>
          </div>
          <hr />
          <div>
            <Button type="submit" disabled={isSubmitting} variant="primary">
              {isSubmitting && (
                <>
                  <Spinner animation="border" variant="light" size="sm" />
                  &nbsp;&nbsp;
                </>
              )}
              Save
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="button" onClick={handleCancel} variant="secondary">
              Cancel
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
